import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import PageLayout from "examples/LayoutContainers/PageLayout";

// Images
import appIcon from "assets/images/appIcon.png";

function BasicLayout({ children }) {
  return (
    <PageLayout>
      <Grid container height="100vh">
        <Grid
          item
          xs={12}
          md={5}
          sx={({ functions: { linearGradient }, palette: { gradients } }) => ({
            position: "relative",
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            backgroundImage: linearGradient(gradients.info.main, gradients.info.state),
            height: "100vh",
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              backgroundImage:
                "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.06) 0, transparent 40%)," +
                "radial-gradient(circle at 80% 70%, rgba(255,255,255,0.05) 0, transparent 45%)",
            },
          })}
        >
          <MDBox
            sx={{
              position: "relative",
              zIndex: 1,
              textAlign: "center",
              px: 4,
            }}
          >
            <MDBox
              component="img"
              src={appIcon}
              alt="App logo"
              sx={{
                width: { xs: 220, md: 280 },
                height: "auto",
                mb: 3,
              }}
            />
            <MDTypography variant="h3" fontWeight="bold" color="white">
              Afford a car Ghana
            </MDTypography>
            <MDTypography
              variant="body"
              color="white"
              opacity={1}
              mt={1}
              sx={{ letterSpacing: 0.3 }}
            >
              Admin Dashboard
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100vh"
          px={2}
          sx={{ backgroundColor: ({ palette }) => palette.background.default }}
        >
          <MDBox width="100%" maxWidth="380px">
            {children}
          </MDBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
